import React from 'react';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import img2 from '../smile.png';

function CardThree() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid item>
      <Grid container justifyContent="center" alignItems="center" sx={{ padding: '20px' }}>
        <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 }, textAlign: 'center' }}>
          <Typography sx={{ marginBottom: '10px', fontSize: '35px', fontWeight: 500 }}>
            Smile Correction
          </Typography>
          <Typography
            sx={{
              fontSize: '20px',
              marginBottom: '15px',
              lineHeight: '2.0',
              paddingLeft: isSmallScreen ? '10px' : '25px',
              paddingRight: isSmallScreen ? '10px' : '25px'
            }}
          >
            Smile correction allows us to create attractive smiles for all our patients using a
            combination of bleaching, orthodontic treatment, implants, veneers, laminates, and
            crowns and bridges. In some cases, the treatment can be completed in less than an hour
            by using composite resin.
          </Typography>
          <Typography
            sx={{
              fontSize: '20px',
              marginBottom: '15px',
              lineHeight: '2.0',
              paddingLeft: isSmallScreen ? '10px' : '25px',
              paddingRight: isSmallScreen ? '10px' : '25px'
            }}
          >
            We have in-house doctors from different dental specialties to give you the best possible
            smile with the least wait time.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ order: { xs: 1, md: 2 }, padding: isSmallScreen ? '10px' : '18px' }}
        >
          <img
            src={img2}
            alt="Second Half Image"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CardThree;
